import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  { q: "What services does Graphic Lines offer?", a: "We provide graphic designing, video editing, digital marketing, social media management, branding, and ads management to help businesses grow online." },
  { q: "Do you work with international clients?", a: "Yes, we serve clients worldwide and provide tailored digital solutions for businesses of all sizes." },
  { q: "How long does a project take?", a: "Project timelines vary depending on complexity, but we always focus on high-quality results delivered efficiently." },
  { q: "Can you create customized solutions for my business?", a: "Absolutely! Every strategy and project is customized to meet your brand's goals and target audience." },
  { q: "How can I start working with Graphic Lines?", a: "Simply contact us via our website or social media, and our team will guide you step-by-step to get your project started." },
];

const FAQSection = () => {
  return (
    <section className="py-12 md:py-20 bg-surface-alt">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-8 md:mb-12">
          <span className="text-xs font-semibold tracking-widest uppercase text-primary mb-2 block">FAQ</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="bg-card border border-border rounded-xl md:rounded-2xl px-4 md:px-6 overflow-hidden">
              <AccordionTrigger className="text-xs md:text-sm font-semibold text-foreground hover:text-primary py-4 md:py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-xs md:text-sm text-muted-foreground pb-4 md:pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
